import React from 'react';
import PropTypes from 'prop-types';
import './table-header-cell.scss';
import GeckoTableCell from '../table-cell/table-cell.jsx';
import { GeckoIcon } from '../../';
import { GeckoTableCellModel, GeckoPaginationModel } from '../../../models';
import { TooltipIdStr, OverlayTrigger, Tooltip } from '../../../';

class GeckoTableHeaderCell extends GeckoTableCell {
  sortKey() {
    if (this.col().sortable && typeof this.col().sortable === 'string') {
      return this.col().sortable;
    } else if (this.col().sortable) {
      return this.col().key;
    }
    return false;
  }

  sortHandler() {
    if (this.isSortable()) this.pagination().changeOrder(this.sortKey());
    return;
  }

  pagination() {
    return this.props.pagination;
  }

  isSortable() {
    return this.sortKey() && this.pagination().changeOrder;
  }

  isOrdered() {
    return this.pagination().order_by === this.sortKey();
  }

  isASC() {
    return this.pagination().sort === 'ASC';
  }

  isDESC() {
    return this.pagination().sort === 'DESC';
  }

  renderSortControls() {
    if (this.isSortable()) {
      return (
        <span className="gecko-table-header-cell-sort-controls">
          <GeckoIcon icon="fas fa-sort" />
          {this.isOrdered() && this.isASC() ? (
            <GeckoIcon icon="fas fa-sort-up" />
          ) : null}
          {this.isOrdered() && this.isDESC() ? (
            <GeckoIcon icon="fas fa-sort-down" />
          ) : null}
        </span>
      );
    }
    return null;
  }

  icon() {
    return this.props.col.icon;
  }

  renderTooltipIcon() {
    const tipId = this.props.col.id || `${this.props.col.name}_col`;
    if (this.icon()) {
      return (
        <span>
          {this.props.col.description ? (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id={TooltipIdStr(tipId)}>
                  {this.props.col.description}
                </Tooltip>
              }
            >
              <i id={TooltipIdStr(tipId)}>
                <GeckoIcon icon="fas fa-question-circle" />
              </i>
            </OverlayTrigger>
          ) : null}
        </span>
      );
    }
    return null;
  }

  render() {
    return (
      <React.Fragment>
        <th
          className={this.renderClasses(true)}
          style={this.renderStyles()}
          onClick={this.sortHandler.bind(this)}
        >
          <div className="gecko-table-header-cell-contents">
            <div>
              {this.props.col.name}
              {this.renderTooltipIcon()}
            </div>
            {this.renderSortControls()}
          </div>
        </th>
      </React.Fragment>
    );
  }
}

GeckoTableHeaderCell.defaultProps = {
  col: {},
  pagination: {},
};

GeckoTableHeaderCell.propTypes = {
  col: PropTypes.shape(GeckoTableCellModel).isRequired,
  pagination: PropTypes.shape(GeckoPaginationModel),
};

export default GeckoTableHeaderCell;
